import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useNewLeadValidation(onSubmit) {
  const initialValues = {
    clientId: '',
    holdingId: '',
    source: '',
    useCompanyData: false,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      clientId: Yup.string().required('El campo cliente es requerido'),
      holdingId: Yup.string().required('El campo bien es requerido'),
      source: Yup.string().required('El campo fuente es requerido'),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
